export default "__VITE_ASSET__0SgXy6l___"